import React, { useState } from "react";
import { notification, Form, Spin } from "antd";
import CustomInput from "../../components/common/Input/CustomInput";
import CustomButton from "../../components/common/button/CustomButton";
import VerifyToken from "./verifyToken";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import authService from "services/authService";
import RouteEnum from "constants/RouteEnum";
import { saveUser } from "utilities/authSession";
import { useNavigate } from "react-router-dom";

const LoginForm = ({ onFinish, onFinishFailed }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isVerify, setIsVerify] = useState(false);
  const [isPopup, setIsPopup] = useState(true);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [userId, setUserId] = useState();
  const { t } = useTranslation();
  const handleLogin = async (values) => {
    try {
      setLoading(true); // Set loading to true when starting the API request

      const result = await authService.login(values);
      if (result.status === "authenticated") {
        saveUser(result.user, result.csrf_token);
        navigate(RouteEnum.Extractpdf);
        return;
      }
      setIsVerify(true);
      setQrCodeUrl(result.qrCodeImageUrl || "");
      setUserId(result.challenge_id);
    } catch (error) {
      console.error("Login failed", error);
      notification.error({
        message: t("loginError"),
        description: t("genericError"),
      });
    } finally {
      setLoading(false);
    }
  };

  const toggleLoginForm = () => {
    setIsPopup(true);
    setIsVerify(false);
  };

  return (
    <Spin spinning={loading} tip={t("loading")} size="large">
      <div
        className="login-form-container"
        style={{ maxWidth: "600px", margin: "0 auto" }}
      >
        {isPopup && isVerify ? (
          <VerifyToken
            qrCodeUrl={qrCodeUrl}
            user={userId}
            toggleLoginForm={toggleLoginForm}
          />
        ) : (
          <Form
            name="login"
            labelCol={{ span: 0 }}
            wrapperCol={{ span: 45 }}
            onFinish={handleLogin}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <div className="mt-4 pt-2 login-inputs mail-icon">
              <label className="form-label">{t("email")}</label>
              <CustomInput
                addon="mail"
                name="email"
                type="text"
                className="br30"
                placeholder={t("enterEmail")}
                rules={[
                  {
                    type: "email",
                    message: t("invalidEmail"),
                  },
                  {
                    required: true,
                    message: t("emailEmpty"),
                  },
                ]}
              />
            </div>
            <div className="mt-0 login-inputs lock-icon">
              <label className="form-label">{t("password")}</label>
              <CustomInput
                addon="lock"
                name="password"
                type="password"
                placeholder={t("password")}
                className="mb-1 br30 login-password-icon"
                rules={[
                  {
                    required: true,
                    message: t("passwordEmpty"),
                  },
                ]}
              />
            </div>
            <div className="d-flex justify-content-between mb-3">
              <div className="form-check">
                {/* remember-me on the login form is intentionally hidden;
                    the working remember-me lives on the MFA screen */}
              </div>
              <div className="">
                <Link to={RouteEnum.ForgotPassword}>{t("ForgotPassword")}</Link>
              </div>
            </div>
            <div>
              <CustomButton
                label={t("loginOrSignup")}
                type="primary"
                htmlType="submit"
                className="btn-blue font-color w-100 br8 h44"
                navigate={false}
                span_className="poppins-semibold fs16"
              />
            </div>
            <div className="d-flex justify-content-center">
             <span className="link-info">{t("NoAccount")}</span>
             <span className="ms-1">{t("inviteOnlySignup")}</span>
            </div>
          </Form>
        )}
      </div>
    </Spin>
  );
};

export default LoginForm;
